import { useState } from 'react'

import {
  PAGE_SIZE,
  useGetLicenseRequestSubmissionsQuery,
} from '@disco/state-management/api/license-requests'
import type { ClientLibraryId } from 'types/client-library'

export type { LicenseRequestSubmission } from '@disco/state-management/api/license-requests'

export function useLicenseRequestSubmissions(
  libraryId: ClientLibraryId,
  ordering: string,
) {
  const [page, setPage] = useState(1)
  const [prevOrdering, setPrevOrdering] = useState(ordering)

  if (prevOrdering !== ordering) {
    setPrevOrdering(ordering)
    setPage(1)
  }

  const { data, isLoading, isFetching, error } =
    useGetLicenseRequestSubmissionsQuery({ libraryId, ordering, page })

  const total = data?.count ?? 0
  const start = total === 0 ? 0 : (page - 1) * PAGE_SIZE + 1
  const end = Math.min(page * PAGE_SIZE, total)
  const hasNext = Boolean(data?.next)
  const hasPrev = page > 1

  const goNext = () => {
    if (hasNext) {
      setPage(p => p + 1)
    }
  }

  const goPrev = () => {
    if (hasPrev) {
      setPage(p => p - 1)
    }
  }

  return {
    submissions: data?.results ?? [],
    total,
    page,
    start,
    end,
    hasNext,
    hasPrev,
    goNext,
    goPrev,
    isLoading: isLoading || isFetching,
    error,
  }
}
